// src/data/vocabulary/sets/m1/index.js

import Routines from './Daily routines.json';
import FamilyMembers from './Family members.json';
import FoodAndMeals from './Food and meals.json';
import Furniture from './Furniture.json';
import Rooms from './Rooms.json';
import objectpronouns from './objectpronouns.json';


export const VOCABULARY_M2_U1 = [
  Routines,
  FamilyMembers,
  FoodAndMeals,
  Furniture,
  Rooms,
  objectpronouns
];
